<template>
  <div class="voucher pa-2">
    <div class="voucher__merchant text--medium text--large mb-1" v-if="merchant">
      {{ merchant }}
    </div>
    <div class="voucher__delimiter my-2"></div>
    <div class="voucher__data">
      <div class="voucher__data-row" v-for="(row, index) of computedData.data" :key="index">
        <div class="voucher__data-column">{{ row.name }}</div>
        <div class="voucher__data-column text--right">{{ row.value }}</div>
      </div>
    </div>
    <div class="voucher__qr" v-if="computedData.sourceQr">
      <qr-code :content="computedData.sourceQr"></qr-code>
    </div>
    <div class="voucher__thank-msg text--x-large text--medium mt-2 mb-1">{{$t('components.Voucher.thanks')}}</div>
    <div class="voucher__id text--xs-small" style="word-wrap: break-word;">{{$t('components.Voucher.deviceId')}} {{ computedData.deviceUid }}</div>
  </div>
</template>

<script>
import QrCode from '@/ui/elements/QrCode'

import toHumanDate from '@/mixins/toHumanDate'
import toCurrency from '@/mixins/toCurrency'

export default {
  mixins: [toHumanDate, toCurrency],

  components: {
    QrCode
  },

  props: {
    merchant: {
      type: String,
      default: 'R.O.C.S.'
    },
    data: {
      type: Object,
      default: () => {
        return {
          amount: 0,
          checkDate: null,
          currency: null,
          deviceUid: null,
          fn: null,
          number: null,
          fpd: null,
          sourceQr: null
        }
      }
    }
  },

  computed: {
    computedData () {
      return {
        data: [
          {
            name: this.$i18n.t('components.Voucher.FN'),
            value: this.data.fn ? this.data.fn : '--'
          },
          {
            name: this.$i18n.t('components.Voucher.Date'),
            value: this.data.checkDate ? this.toSimpleDate(this.data.checkDate) : '--'
          },
          // amount: this.data.amount ? this.data.amount : null,
          {
            name: this.$i18n.t('components.Voucher.Sum'),
            value: this.data.amount ? this.toCurrency(this.data.amount, this.data.currency ? this.data.currency : '') : '--'
          },
          {
            name: this.$i18n.t('components.Voucher.FD'),
            value: this.data.number ? this.data.number : '--'
          },
          {
            name: this.$i18n.t('components.Voucher.FP'),
            value: this.data.fpd ? this.data.fpd : '--'
          }
        ],

        sourceQr: this.data.sourceQr ? this.data.sourceQr : null,

        deviceUid: this.data.deviceUid ? this.data.deviceUid : '--'
      }
    },

    currLocale () {
      return this.$i18n.locale
    }
  },

  methods: {
    toSimpleDate (incomingDate) {
      const date = new Date(incomingDate)

      const dateStringOptions = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC'
      }

      return date.toLocaleString(this.currLocale, dateStringOptions)
    }
  }
}
</script>

<style lang="scss">
  .voucher {
    width: 28.8rem;
    background-color: $color-white;

    &__merchant {
      font-weight: 500;
      font-size: 2.4rem;
    }

    &__data-row {
      display: flex;
      justify-content: space-between;
      font-size: 1.1rem;

      &:not(:last-child) {
        margin-bottom: .5rem;
      }
    }

    &__delimiter {
      border-bottom: 2px lighten($color-black, 20%) dashed;
    }
  }
</style>
